self.process ??= { env: {} };
